import { DataSyncStatusSchema } from '../../shared/data-sync';
export const showDataSyncContract = {
    method: 'GET',
    path: '/api/v2/data-sync',
    description: "Show the tenant's data source and its open sync run",
    responseSchema: DataSyncStatusSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source'
        }
    }
};

//# sourceMappingURL=show-data-sync.contract.js.map